<template>
  <div class="d-flex flex-column align-center justify-center" style="min-height: 80vh;">
    <v-progress-circular indeterminate color="primary" size="64" width="6" class="mb-4" />
    <h2 class="text-h5 font-weight-medium">Chargement de votre espace…</h2>
  </div>
</template>

<script>
export default {
  name: 'Home',
  mounted() {
    // Redirige immédiatement en fonction de l'authentification
    if (this.$store.state.isAuthenticated) {
      this.$router.replace({ name: 'savings.dashboard' })
    } else {
      this.$router.replace({ name: 'login' })
    }
  }
}
</script>
